module.exports = __webpack_public_path__ + "src/assets/bg.6bd3535b.png";